export { default as useLifestylesFilterCategories } from './useLifestylesFilterCategories';
